<template>
  <!-- 个人资料 -->
  <div class="container">
    <div class="row">
      <div class="col-md-8" style="margin: 0 auto">
        <div class="intrPages">
          <div class="intr-content">
            <div class="rolItem">
              <div @click="update('avatar')">
                <mt-cell title="头像">
                  <div class="profile-box">
                    <img :src="userInfo.avatar" />
                  </div>
                </mt-cell>
              </div>
            </div>
            <div class="rolItem">
              <div @click="update('nickName')">
                <mt-cell title="昵称" is-link>
                  <span style="color: #333">{{ userInfo.nickName }}</span>
                </mt-cell>
              </div>
            </div>
            <div class="rolItem">
              <div @click="update('name')">
                <mt-cell title="真实姓名" is-link>
                  <span style="color: #333">{{ userInfo.name }}</span>
                </mt-cell>
              </div>
              <div @click="update('gender')">
                <mt-cell title="性别" is-link>
                  <span style="color: #333">{{
                    userInfo.gender == 1 ? '男' : '女'
                  }}</span>
                </mt-cell>
              </div>
            </div>
            <div class="rolItem">
              <div @click="update('mobile')">
                <mt-cell title="手机号" is-link>
                  <span style="color: #333">{{ userInfo.mobile }}</span>
                </mt-cell>
              </div>
            </div>
            <div class="rolItem" v-show="userInfo.userType === 2">
              <mt-cell title="工作单位">
                <span style="color: #333; margin-right: 22px">{{
                  userInfo.hospital
                }}</span>
              </mt-cell>

              <mt-cell title="职称">
                <span style="color: #333; margin-right: 22px">{{
                  userInfo.cerJob
                }}</span>
              </mt-cell>
            </div>
            <div class="rolItem" v-show="userInfo.userType === 2">
              <mt-cell title="亚专业(主)">
                <span style="color: #333; margin-right: 22px">{{
                  userInfo.cerSpeciality
                }}</span>
              </mt-cell>
              <mt-cell title="亚专业(副)">
                <span style="color: #333; margin-right: 22px">{{
                  userInfo.cerOtherSpeciality
                }}</span>
              </mt-cell>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gender: '',
      userInfo: {
        avatar: null,
        cerJob: null,
        cerOtherSpeciality: null,
        cerSpeciality: null,
        certificateUrl: null,
        gender: null,
        hospital: null,
        idCard: null,
        mobile: null,
        name: null,
        nickName: null,
      },
    }
  },

  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.getUserInfoByOPenId()
    this.noShare()
  },
  methods: {
    // 修改
    update(cellName) {
      // this.$router.push({
      //   path: '/replaceMobile',
      //   query: {
      //     cellName: cellName,
      //   },
      // })
      const routeData = this.$router.resolve({
        path: '/replaceMobile',
        query: {
          cellName: cellName
        }
      })
      window.open(routeData.href, '_blank')
    },
    // 获取当前用户信息
    getUserInfoByOPenId() {
      if (this.userInfo) {
        if (this.userInfo.mobile) {
          this.userInfo.mobile =
            this.userInfo.mobile.substr(0, 3) +
            '****' +
            this.userInfo.mobile.substr(7)
        }
        if (this.userInfo.idCard) {
          this.userInfo.idCard =
            this.userInfo.idCard.substr(0, 3) +
            '***********' +
            this.userInfo.idCard.substr(14)
        }
        this.gender = this.userInfo.gender === 1 ? '男' : '女'
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.rolItem {
  background-color: #eee;
  padding-bottom: 1rem;
}
.intrPages {
  margin-bottom: 1rem;
}
.phoneCata {
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    border: 0;
    font-size: 16px;
    text-align: center;
    background-color: $theme-color;
    color: #fff;
    line-height: 4rem;
    margin-bottom: 2rem;
  }
}
.cellInput {
  border: 1px solid #bfbfbf;
  margin-bottom: 2rem;
}
/deep/ .mint-popup-right {
  padding: 2rem;
  box-sizing: border-box;
  width: 100%;
  color: #333;
  text-align: center;
  p {
    font-size: 18px;
    margin-bottom: 3rem;
  }
}
.profile-box {
  width: 6rem;
  height: 6rem;
  border: 2px solid #bfbfbf;
  border-radius: 50%;
  float: left;
  margin: 1rem 1rem;
  img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 50%;
  }
}

.save {
  width: 100%;
  border: 0;
  font-size: 16px;
  text-align: center;
  background-color: $theme-color;
  color: #fff;
  line-height: 5rem;
}
.exLogin {
  text-align: center;
  // box-sizing: border-box;
  width: 100%;
  font-size: $font-title;
  background-color: #eee;
  height: 60px;
  padding-top: 1rem;
  margin-bottom: 1rem;
  border-bottom: 10px solid #eee;
  span {
    background-color: #fff;
    display: block;
    height: 100%;
    line-height: 60px;
  }
}
</style>
